import Mustache from 'mustache';
import ajax from '../libs/ajax';
import initModal from './modal';
import ajaxSearchCars from './sopimus-ajax-search-car';

export default searchOptions => {
  ajax.ajaxRequest({
    target: 'getCarsByOptions',
    method: 'POST',
    data: searchOptions,
    callback: function(response) {
      console.log('getCarsByOptions', response);
      console.log('getCarsByOptions[cars]', response['cars']);
      const sopimusCarsTemplate = document.getElementById('sopimusCarsResult').innerHTML;
      const resultCarsDiv = document.querySelector('.sopimus-result-cars').children[0];
      const ulPagination = document.getElementById('pagination');

      resultCarsDiv.innerHTML = '';
      ulPagination.innerHTML = '';
      if (Object.keys(response).length === 0) {
        resultCarsDiv.innerHTML = '<h3>Autoja ei löytynyt valitsemillasi ehdoilla</h3>';
      } else {
        for (let x = 1; x <= response.totalPages; x++) {
          ulPagination.innerHTML += `<li><a data-page-number="${x}" class="sopimus-pagination" href="?page=${x}">${x}</a></li>`;
        }
        let sopimusPagination = document.getElementsByClassName('sopimus-pagination');
        if (sopimusPagination) {
          for (let i = 0; i < sopimusPagination.length; i++) {
            sopimusPagination[i].addEventListener('click', element => {
              element.preventDefault();
              const pageNumber = sopimusPagination[i].dataset.pageNumber;
              window.searchOptions.page = pageNumber;

              ajaxSearchCars(window.searchOptions);
            });
          }
        }
        response['cars'].forEach(car => {
          const leasing = response.leasing;
          const leasingOptions = {};
          const mileageOptions = [];
          leasing.forEach(option => {
            if (car.car_id === option.car_id) {
              if (!leasingOptions[option.leasing_period]) {
                leasingOptions[option.leasing_period] = [
                  {
                    mileage: option.mileage,
                    residual_value: option.residual_value,
                    tyres_price: option.tyres_price
                  }
                ];
              } else {
                leasingOptions[option.leasing_period].push({
                  mileage: option.mileage,
                  residual_value: option.residual_value,
                  tyres_price: option.tyres_price
                });
              }

              if (mileageOptions.indexOf(option.mileage) < 0) {
                mileageOptions.push(option.mileage);
              }
            }
          });

          // Let first value is minMonthlyTranche then compare with another
          let minMonthlyTranche = leasing[0].calculated_monthly_price;
          leasing.forEach(option => {
            if (car.car_id === option.car_id) option.calculated_monthly_price > minMonthlyTranche ? '' : (minMonthlyTranche = option.calculated_monthly_price);
          });
          const renderData = {
            ...car,
            car: JSON.stringify(car),
            leasingOptions: JSON.stringify(leasingOptions),
            mileageOptions: JSON.stringify(mileageOptions),
            image: car.image,
            minMonthlyTranche
          };
          resultCarsDiv.innerHTML += Mustache.render(sopimusCarsTemplate, renderData);
          initModal();
        });
      }
    }
  });
};
